// Reference trigger detector for the composer's autocomplete dropdown.
// Supports multiple trigger patterns: @person, #channel, ##ticket,
// @@event, +reference (docs/notes/kb).

// Trigger definitions in priority order (longest prefix first).
const TRIGGERS = [
  { prefix: '@@', type: 'event' },
  { prefix: '##', type: 'ticket' },
  { prefix: '@', type: 'person' },
  { prefix: '#', type: 'channel' },
  { prefix: '+', type: 'reference' }
]

// Returns { type, query, start, end } or null.
// e.g. body="hey @ni|" → { type:'person', query:'ni', start:4, end:6 }
// e.g. body="see #gen|" → { type:'channel', query:'gen', start:4, end:8 }
export const detectReferenceTrigger = (body, caret) => {
  if (caret == null || !body) return null
  const upToCaret = body.slice(0, caret)

  for (const { prefix, type } of TRIGGERS) {
    const idx = upToCaret.lastIndexOf(prefix)
    if (idx < 0) continue
    // Must be at start or preceded by whitespace.
    if (idx > 0 && !/\s/.test(body[idx - 1])) continue
    const after = upToCaret.slice(idx + prefix.length)
    // Allow alphanumeric, dots, underscores, dashes, spaces (for titles).
    if (!/^[a-zA-Z0-9._\- ]*$/.test(after)) continue
    return { type, query: after, start: idx, end: caret }
  }
  return null
}

// Keep the old export for backward compatibility.
export const detectMentionTrigger = (body, caret) => {
  const result = detectReferenceTrigger(body, caret)
  if (!result || result.type !== 'person') return null
  return { query: result.query, start: result.start, end: result.end }
}
